

























































































import { http } from '@/services';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ProductsHome extends Vue {
  protected products: Array<any> = [];
  protected newProduct = {
    name: '',
    description: '',
  };
  protected showDialog: boolean = false;
  protected isValid: boolean = false;
  protected rules = {
    name: [
      (name: string) =>
        (name.trim().length >= 3 && name.trim().length <= 60) ||
        'O nome deve conter no mínimo 3 e no máximo 60 caracteres.',
    ],
    description: [
      (description: string) =>
        (description.trim().length === 0 || description.trim().length <= 150) ||
        'A descrição deve conter no máximo 150 caracteres.',
    ],
  };

  protected async mounted(): Promise<void> {
    this.products.push(...(await http.get('/products')).data);
  }

  protected async save(): Promise<void> {
    await http.post('/products', this.newProduct);
    this.products.splice(0);
    this.products.push(...(await http.get('/products')).data);
    this.showDialog = false;
    this.resetModel();
  }

  protected resetModel(): void {
    this.newProduct.name = '';
    this.newProduct.description = '';
  }
}
